<div class="dropdownMenu d-flex">
    <div class="export">
<div class="export-actionbutton-icon">
    <img src="assets/images/exportwhite.svg" style="height: 14px;">
</div>
<div class="export-actionbutton-text">
    <span> Export</span>
</div>
<ul class="dropdownMenu-content" style="text-align: center;top: 33px;">
    <span class="dropdownMenu-content-option"><a
            >Excel</a></span>
    <span class="dropdownMenu-content-option"><a
           >PDF</a></span>
</ul>
</div>
</div>
